__turbopack_context__.v({
  "grid": "grid-module__qoPqaW__grid",
  "scrollable": "grid-module__qoPqaW__scrollable",
});
